import './styles.styl'
import React from 'react'

export default class TextfieldModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: (typeof props.value === 'string') ? props.value.trim() : ''
    }
  }

  componentWillReceiveProps (nextProps) {
    if (typeof nextProps.value === 'string' && nextProps.trim().value !== '') {
      this.setState({ value: nextProps.value })
    }
  }

  save () {
    const value = String(this.state.value)
    this.setState({ value: (typeof this.props.value === 'string') ? this.props.value.trim() : '' })
    return typeof this.props.onSave === 'function' ? this.props.onSave(this.props.id, value) : null
  }

  cancel () {
    this.setState({ value: (typeof this.props.value === 'string') ? this.props.value.trim() : '' })
    return typeof this.props.onCancel === 'function' ? this.props.onCancel(this.props.id) : null
  }

  render () {
    return (
      <section className='overlay-fixed'>
        <div className='dialog'>
          <textarea onChange={e => this.setState({ value: e.target.value })}>{this.state.value}</textarea>
          <div className='footer'>
            <a className='btn btn-sm btn-link' onClick={() => this.cancel()}>Annuleer</a>
            <a className='btn btn-sm btn-success' onClick={() => this.save()}>Opslaan</a>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/textfield-modal/index.js